import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "fo-header" }
const _hoisted_3 = { class: "fo-header-top" }
const _hoisted_4 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_5 = {
  key: 1,
  class: "fo-subtitulo"
}
const _hoisted_6 = {
  key: 0,
  class: "fo-vacio"
}
const _hoisted_7 = { class: "fo-aviso" }
const _hoisted_8 = { class: "fo-aviso-cuerpo" }
const _hoisted_9 = { class: "fo-crear" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "fo-crear-fechas" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "estado-row" }
const _hoisted_17 = { class: "estado-info" }
const _hoisted_18 = { class: "vigencia-texto" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "config-selector"
}
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "ficha-info" }
const _hoisted_23 = {
  key: 0,
  class: "fi-titulo"
}
const _hoisted_24 = { class: "fi-cubiertos" }
const _hoisted_25 = { class: "fi-cubiertos-header" }
const _hoisted_26 = {
  key: 0,
  class: "lista-cubiertos"
}
const _hoisted_27 = {
  key: 0,
  class: "ic-ordinal"
}
const _hoisted_28 = { class: "ic-texto" }
const _hoisted_29 = { class: "ic-componente" }
const _hoisted_30 = { class: "ic-enunciado" }
const _hoisted_31 = { class: "ic-preguntas" }
const _hoisted_32 = {
  key: 1,
  class: "fi-vacio"
}
const _hoisted_33 = {
  key: 1,
  class: "fi-instrucciones"
}
const _hoisted_34 = { class: "tabs" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_37 = { class: "marco" }
const _hoisted_38 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_39 = {
  key: 0,
  class: "vacio"
}
const _hoisted_40 = { class: "form-card-head" }
const _hoisted_41 = { class: "form-card-grupo" }
const _hoisted_42 = { class: "form-card-acciones" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 1,
  class: "muted"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "snapshot-lista"
}
const _hoisted_48 = { class: "snap-header" }
const _hoisted_49 = { class: "snap-n" }
const _hoisted_50 = { class: "snap-enunciado" }
const _hoisted_51 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_52 = {
  key: 0,
  class: "aviso-readonly"
}
const _hoisted_53 = {
  key: 1,
  class: "dest-tabs"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_56 = {
  key: 0,
  class: "dest-grupo"
}
const _hoisted_57 = {
  key: 0,
  class: "dest-tabla"
}
const _hoisted_58 = {
  key: 1,
  class: "muted"
}
const _hoisted_59 = {
  key: 3,
  class: "dest-input-wrap"
}
const _hoisted_60 = { class: "dest-label-row" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = { class: "vigencia-row" }
const _hoisted_64 = { class: "vigencia-campo" }
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = { class: "vigencia-campo" }
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 4,
  class: "tab-footer"
}
const _hoisted_70 = ["disabled", "onClick"]
const _hoisted_71 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_72 = { class: "respuestas-head" }
const _hoisted_73 = { class: "total-badge" }
const _hoisted_74 = { class: "vista-toggle" }
const _hoisted_75 = ["title"]
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 0,
  class: "vacio"
}
const _hoisted_78 = {
  key: 1,
  class: "dest-tabs"
}
const _hoisted_79 = ["onClick"]
const _hoisted_80 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_81 = {
  key: 0,
  class: "resp-grupo"
}
const _hoisted_82 = {
  key: 0,
  class: "resp-personas"
}
const _hoisted_83 = { class: "resp-personas-label" }
const _hoisted_84 = ["title"]
const _hoisted_85 = { class: "resp-enunciado" }
const _hoisted_86 = {
  key: 0,
  class: "resp-promedio"
}
const _hoisted_87 = { class: "prom-valor" }
const _hoisted_88 = { class: "prom-bar-wrap" }
const _hoisted_89 = {
  key: 1,
  class: "resp-textos"
}
const _hoisted_90 = { class: "resp-texto-autor" }
const _hoisted_91 = {
  key: 0,
  class: "persona-filtro"
}
const _hoisted_92 = ["value"]
const _hoisted_93 = {
  key: 1,
  class: "vacio"
}
const _hoisted_94 = { class: "persona-head" }
const _hoisted_95 = { class: "persona-nombre" }
const _hoisted_96 = {
  key: 0,
  class: "persona-email"
}
const _hoisted_97 = {
  key: 1,
  class: "persona-rol"
}
const _hoisted_98 = {
  key: 2,
  class: "persona-fecha"
}
const _hoisted_99 = { class: "persona-respuestas" }
const _hoisted_100 = { class: "pr-enunciado" }
const _hoisted_101 = { class: "pr-valor" }
const _hoisted_102 = {
  key: 3,
  class: "tab-content"
}
const _hoisted_103 = {
  key: 0,
  class: "cal-existente"
}
const _hoisted_104 = { class: "cal-lista" }
const _hoisted_105 = { class: "cal-ind-cab" }
const _hoisted_106 = {
  key: 0,
  class: "ic-ordinal"
}
const _hoisted_107 = { class: "ic-texto" }
const _hoisted_108 = {
  key: 0,
  class: "ic-aspecto"
}
const _hoisted_109 = {
  key: 0,
  class: "cal-grid"
}
const _hoisted_110 = { class: "cal-item" }
const _hoisted_111 = {
  key: 0,
  class: "cal-item"
}
const _hoisted_112 = {
  key: 1,
  class: "cal-item"
}
const _hoisted_113 = { class: "cal-valor" }
const _hoisted_114 = { class: "cal-item" }
const _hoisted_115 = { class: "cal-valor cal-valor--tenue" }
const _hoisted_116 = {
  key: 1,
  class: "cal-sin-nota"
}
const _hoisted_117 = { class: "form-group" }
const _hoisted_118 = ["min", "max"]
const _hoisted_119 = { class: "form-group" }
const _hoisted_120 = { class: "form-group" }
const _hoisted_121 = { class: "tab-footer" }
const _hoisted_122 = ["disabled"]
const _hoisted_123 = {
  key: 2,
  class: "cal-form"
}
const _hoisted_124 = { class: "cal-aviso" }
const _hoisted_125 = ["disabled"]

import { ref, computed, onMounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { read, utils } from 'xlsx'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import ContactosPreviosSelector from '@/components/ContactosPreviosSelector.vue'
import { useGestionConfiguracionInstrumento } from '@/store/GestionConfiguracionInstrumento'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useModelo } from '@/store/GestionModelo'
import useAutenticar from '@/store/IngresoAutenticar'
import { primerError } from '@/services/http'
import type ConfiguracionInstrumento from '@/interfaces/ConfiguracionInstrumento'
import type { FormularioGoogle, IndicadorCubierto, RespuestasFormulario, RespuestaIndividual, Participacion,} from '@/interfaces/ConfiguracionInstrumento'

interface TextoRespuesta {
  texto: string
  nombre: string
}

interface GrupoRespuesta {
  enunciado: string
  tieneValores: boolean
  promedio: number
  textos: TextoRespuesta[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FichaOpinion',
  setup(__props) {

/**
 * Ficha de evidencia de opinión, alimentada por formularios.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ficha-opinion` (FichaOpinion) — permiso `evidencias.subir`
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const route = useRoute()
const router = useRouter()
const configStore = useGestionConfiguracionInstrumento()
const instrumentoStore = useGestionInstrumento()
const versionesStore = useGestionVersiones()
const modeloStore = useModelo()
const authStore = useAutenticar()
const escalaMax = ref<number>(5)
const nombreVersion = ref('')
const loading = ref(false)
const loadingAccion = ref(false)
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')
const instrumento = ref('')
const instrumentoNombre = ref('')
const configuraciones = ref<ConfiguracionInstrumento[]>([])
const configuracion = ref<ConfiguracionInstrumento | null>(null)
const configSeleccionadaId = ref<number | null>(null)
const respuestas = ref<RespuestasFormulario[]>([])
const participacion = ref<Participacion | null>(null)
const tabActiva = ref<'formularios' | 'destinatarios' | 'respuestas' | 'calificacion'>('formularios')
const vistaRespuestas = ref<'pregunta' | 'persona'>('pregunta')
const grupoActivo = ref<number | null>(null)
const grupoActivoRespuestas = ref<number | null>(null)
const personaFiltrada = ref<string | null>(null)


const publicando = ref(false)
const indicadoresExpandidos = ref(false)

function claseSemaforoDesdeNivel(nivel: string | null | undefined): string {
  if (!nivel) return ''
  const n = nivel.toLowerCase()
  if (n.includes('plenamente'))  return 'nivel-excelente'
  if (n.includes('alto grado'))  return 'nivel-alto'
  if (n.includes('aceptabl'))    return 'nivel-medio'
  return 'nivel-bajo'
}

/** Área bajo la que se ofrecen los correos ya usados por grupo de interés. */
const idPrograma = computed<number | null>(() => configuracion.value?.id_programa ?? null)

const idEjecucionActual = computed<number | null>(() => {
  const raw = Array.isArray(route.query.id_ejecucion) ? route.query.id_ejecucion[0] : route.query.id_ejecucion
  const n = Number(raw)
  return Number.isFinite(n) && n > 0 ? n : null
})

function agregarContactosPrevios(idForm: number, elegidos: Array<{ email: string }>) {
  const formulario = formularios.value.find(f => f.id_formulario_google === idForm)
  const yaAsignados = new Set((formulario?.destinatarios ?? []).map((d: any) => d.email.toLowerCase()))
  const yaEscritos = new Set(
    (correosInput.value[idForm] ?? '').split('\n').map(e => e.trim().toLowerCase()).filter(Boolean)
  )

  const nuevos = elegidos
    .map(c => c.email)
    .filter(e => !yaAsignados.has(e.toLowerCase()) && !yaEscritos.has(e.toLowerCase()))

  if (nuevos.length === 0) {
    mostrarMensaje('Esos correos ya estaban en la lista.', 'error')
    return
  }

  const actual = (correosInput.value[idForm] ?? '').trim()
  correosInput.value[idForm] = actual ? `${actual}\n${nuevos.join('\n')}` : nuevos.join('\n')
  mostrarMensaje(`${nuevos.length} correo(s) agregados del banco.`, 'positivo')
}

/**
 * Publica la configuración: es lo que crea los formularios de Google y sus
 * enlaces. Sin este paso no hay nada que enviar ni a quién asignárselo.
 */
async function publicarConfiguracion() {
  if (!configuracion.value) return
  publicando.value = true
  try {
    const result = await configStore.publicar(configuracion.value.id_configuracion)
    if (!result?.ok) {
      const primero = Object.values(result?.errors ?? {}).flat()[0]
      mostrarMensaje(primero ?? 'No se pudieron publicar los formularios.', 'error')
      return
    }
    await cargarConfiguracion(configuracion.value.id_configuracion)
    mostrarMensaje('Formularios publicados. Ya puede asignar destinatarios.', 'positivo')
  } finally {
    publicando.value = false
  }
}

// Alta de la configuración cuando el formulario aún no la tiene
const formNueva = reactive({ titulo: '', instrucciones: '', vigencia_desde: '', vigencia_hasta: '' })
const creando = ref(false)

/**
 * Crea la configuración del formulario. No se envía id_indicador: es una por
 * formulario y los indicadores que cubre salen de sus preguntas.
 */
async function crearConfiguracion() {
  const id = idInstrumento()
  if (!id || !formNueva.titulo.trim()) return

  creando.value = true
  try {
    const result = await configStore.crear({
      id_instrumento: id,
      titulo: formNueva.titulo.trim(),
      instrucciones: formNueva.instrucciones.trim() || undefined,
      vigencia_desde: formNueva.vigencia_desde || undefined,
      vigencia_hasta: formNueva.vigencia_hasta || undefined
    })

    if (!result?.ok || !result.data) {
      const primero = Object.values(result?.errors ?? {}).flat()[0]
      mostrarMensaje(primero ?? 'No se pudo configurar el formulario.', 'error')
      return
    }

    configuraciones.value = [result.data]
    configSeleccionadaId.value = result.data.id_configuracion
    await cargarConfiguracion(result.data.id_configuracion)
    mostrarMensaje('Formulario configurado.', 'positivo')
  } finally {
    creando.value = false
  }
}

const indicadoresCubiertos = computed<IndicadorCubierto[]>(
  () => configuracion.value?.indicadores_cubiertos ?? []
)

const hayCalificacion = computed(() =>
  indicadoresCubiertos.value.some(ind => ind.calificacion?.opinion != null)
)

/**
 * El formulario evalúa un solo indicador y se califica con una nota única, en
 * vez de pregunta por pregunta.
 */
const esFormularioCompleto = computed(
  () => configuracion.value?.modalidad === 'formulario_completo'
)

const formCal = reactive({ valor: 0, observacion: '', comparacion: '' })

/** Nota única del formulario completo (carril RF-07 a nivel de instrumento). */
async function calificarCompleto() {
  if (!configuracion.value) return
  loadingAccion.value = true
  try {
    const idEjecucion = Number(
      Array.isArray(route.query.id_ejecucion) ? route.query.id_ejecucion[0] : route.query.id_ejecucion
    )
    const result = await configStore.calificar(configuracion.value.id_configuracion, {
      valor: formCal.valor,
      observacion: formCal.observacion || undefined,
      comparacion: formCal.comparacion || undefined,
      ...(Number.isFinite(idEjecucion) && idEjecucion > 0 ? { id_ejecucion: idEjecucion } : {})
    })

    if (result.ok) {
      await cargarConfiguracion(configuracion.value.id_configuracion)
      mostrarMensaje('Calificación guardada correctamente.', 'positivo')
    } else {
      mostrarMensaje(primerError(result, 'Error al guardar la calificación.'), 'error')
    }
  } finally {
    loadingAccion.value = false
  }
}

const correosInput = ref<Record<number, string>>({})
// Vigencia que se aplicará a los correos que se carguen en este envío.
const vigenciaDesde = ref<Record<number, string>>({})
const vigenciaHasta = ref<Record<number, string>>({})
const fileInputRef = ref<HTMLInputElement | null>(null)
const formularioExcelActivo = ref<number | null>(null)

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

function formatearFecha(fecha: string | null | undefined): string {
  if (!fecha) return '—'
  const d = new Date(fecha)
  if (isNaN(d.getTime())) return fecha
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'long', year: 'numeric' })
}

const formularios = computed<FormularioGoogle[]>(() => configuracion.value?.formularios ?? [])

const totalRespuestas = computed(() =>
  respuestas.value.reduce((acc, rf) => acc + rf.respuestas.length, 0)
)

// Desglose por grupo para el tooltip del badge de participación.
const tituloParticipacion = computed(() => {
  const p = participacion.value
  if (!p) return ''
  return p.por_formulario
    .map(f => {
      const pct = f.porcentaje === null ? '—' : `${f.porcentaje}%`
      return `${f.grupo_interes ?? 'Grupo'}: ${f.respondieron}/${f.correos_enviados} (${pct})`
    })
    .join('\n')
})

const tabs = computed(() => [
  { id: 'formularios' as const, label: 'Formularios' },
  { id: 'destinatarios' as const, label: 'Destinatarios' },
  { id: 'respuestas' as const, label: 'Respuestas', badge: totalRespuestas.value || undefined },
  { id: 'calificacion' as const, label: 'Calificación' },
])

function idInstrumento(): number | null {
  const raw = route.query.id_instrumento ?? route.params.id_instrumento ?? route.params.id
  const val = Array.isArray(raw) ? raw[0] : raw
  const n = Number(val)
  return Number.isFinite(n) && n > 0 ? n : null
}

onMounted(async () => {
  const id = idInstrumento()
  if (!id) {
    mostrarMensaje('No se encontró id_instrumento en la URL.', 'error')
    return
  }

  loading.value = true
  try {
    const inst = await instrumentoStore.getInstrumentoById(id)
    instrumento.value = inst?.herramienta ?? ''
    instrumentoNombre.value = (inst as any)?.descripcion || inst?.herramienta || ''

    // Se propone como título para no pedir dos veces el mismo nombre.
    if (!formNueva.titulo) formNueva.titulo = instrumentoNombre.value

    const rawVersion = route.query.id_version
    const idVersion = Number(Array.isArray(rawVersion) ? rawVersion[0] : rawVersion)
    if (Number.isFinite(idVersion) && idVersion > 0) {
      const version = await versionesStore.getVersionById(idVersion)
      nombreVersion.value = version?.nombre ?? ''
      if (version?.id_modelo) {
        const modelo = await modeloStore.getModeloById(version.id_modelo)
        if (modelo?.escala_max) escalaMax.value = modelo.escala_max
      }
    }

    await configStore.listar({ id_instrumento: id })

    // La configuración es UNA POR FORMULARIO, así que basta con acotar al
    // instrumento: no se filtra por indicador porque las nuevas nacen sin él
    // (los indicadores que cubre salen de las preguntas).
    configuraciones.value = [...configStore.configuraciones].filter(c => c.id_instrumento === id)

    if (configuraciones.value.length > 0) {
      const ultima = configuraciones.value[configuraciones.value.length - 1]
      configSeleccionadaId.value = ultima.id_configuracion
      await cargarConfiguracion(ultima.id_configuracion)
    }
  } finally {
    loading.value = false
  }
})

async function cargarConfiguracion(idConfig: number) {
  // Cada indicador cubierto llega con SU calificación: se acota a la ejecución
  // en curso y al calificador para no mostrar la nota de otro proceso.
  const params: { id_ejecucion?: number; id_usuario?: number } = {}
  const idEjecucion = Number(
    Array.isArray(route.query.id_ejecucion) ? route.query.id_ejecucion[0] : route.query.id_ejecucion
  )
  if (Number.isFinite(idEjecucion) && idEjecucion > 0) params.id_ejecucion = idEjecucion
  const idUsuario = authStore.usuarioActual?.id
  if (idUsuario) params.id_usuario = idUsuario

  const result = await configStore.obtener(idConfig, params)
  if (result.ok && result.data) {
    configuracion.value = result.data
    participacion.value = result.data.participacion ?? null
    inicializarCorreosInput()
  }
}

async function cargarConfigSeleccionada() {
  if (!configSeleccionadaId.value) return
  loading.value = true
  await cargarConfiguracion(configSeleccionadaId.value)
  respuestas.value = []
  loading.value = false
}

/** Atajo: el caso típico es una carrera de 5 años desde hoy. */
function vigenciaCincoAnios(idForm: number) {
  const hoy = new Date()
  const fin = new Date(hoy)
  fin.setFullYear(fin.getFullYear() + 5)
  vigenciaDesde.value[idForm] = hoy.toISOString().slice(0, 10)
  vigenciaHasta.value[idForm] = fin.toISOString().slice(0, 10)
}

function inicializarCorreosInput() {
  correosInput.value = {}
  vigenciaDesde.value = {}
  vigenciaHasta.value = {}
  for (const f of formularios.value) {
    correosInput.value[f.id_formulario_google] = ''
    vigenciaDesde.value[f.id_formulario_google] = ''
    vigenciaHasta.value[f.id_formulario_google] = ''
  }
  if (!grupoActivo.value && formularios.value.length) {
    grupoActivo.value = formularios.value[0].id_formulario_google
  }
}

async function asignarDestinatariosGrupo(idFormulario: number) {
  if (!configuracion.value) return
  const texto = correosInput.value[idFormulario] ?? ''
  const emails = texto.split('\n').map(e => e.trim()).filter(e => e.includes('@'))
  if (!emails.length) {
    mostrarMensaje('No hay correos nuevos para enviar a este grupo.', 'error')
    return
  }
  loadingAccion.value = true
  // La vigencia viaja con cada correo: el banco la guarda al archivarlos y
  // deja de ofrecerlos cuando caduca.
  const desde = vigenciaDesde.value[idFormulario] || undefined
  const hasta = vigenciaHasta.value[idFormulario] || undefined
  const payload = {
    [idFormulario]: emails.map(email => ({
      email,
      ...(desde ? { vigencia_desde: desde } : {}),
      ...(hasta ? { vigencia_hasta: hasta } : {})
    }))
  }
  const result = await configStore.asignarDestinatarios(
    configuracion.value.id_configuracion,
    payload,
    idEjecucionActual.value
  )
  if (result.ok) {
    const banco = result.data?.contactos_registrados ?? 0
    mostrarMensaje(
      banco > 0
        ? `Enviado. ${banco} correo(s) quedaron en el banco.`
        : 'Formulario enviado a los destinatarios.',
      'positivo'
    )
    correosInput.value[idFormulario] = ''
    await cargarConfiguracion(configuracion.value.id_configuracion)
  } else {
    mostrarMensaje(primerError(result, 'Error al asignar destinatarios.'), 'error')
  }
  loadingAccion.value = false
}

function abrirExcel(idFormulario: number) {
  formularioExcelActivo.value = idFormulario
  fileInputRef.value?.click()
}

function onArchivoExcel(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file || formularioExcelActivo.value == null) return

  const reader = new FileReader()
  reader.onload = (e) => {
    try {
      const data = new Uint8Array(e.target!.result as ArrayBuffer)
      const workbook = read(data, { type: 'array' })
      const sheet = workbook.Sheets[workbook.SheetNames[0]]
      const rows = utils.sheet_to_json<any[]>(sheet, { header: 1 })

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const encontrados: string[] = []
      for (const row of rows) {
        for (const cell of row) {
          const val = String(cell ?? '').trim()
          if (emailRegex.test(val)) encontrados.push(val)
        }
      }

      const idForm = formularioExcelActivo.value!
      const formulario = formularios.value.find(f => f.id_formulario_google === idForm)
      const yaAsignados = new Set((formulario?.destinatarios ?? []).map((d: any) => d.email.toLowerCase()))
      const yaEnTextarea = new Set(
        (correosInput.value[idForm] ?? '').split('\n').map(e => e.trim().toLowerCase()).filter(Boolean)
      )

      const nuevos = [...new Set(encontrados)].filter(
        e => !yaAsignados.has(e.toLowerCase()) && !yaEnTextarea.has(e.toLowerCase())
      )

      if (nuevos.length === 0) {
        mostrarMensaje('No se encontraron correos nuevos en el archivo.', 'error')
      } else {
        const actual = (correosInput.value[idForm] ?? '').trim()
        correosInput.value[idForm] = actual ? `${actual}\n${nuevos.join('\n')}` : nuevos.join('\n')
        mostrarMensaje(`${nuevos.length} correo(s) cargados desde el archivo.`, 'positivo')
      }
    } catch {
      mostrarMensaje('No se pudo leer el archivo. Verifique que sea un Excel o CSV válido.', 'error')
    } finally {
      input.value = ''
    }
  }
  reader.readAsArrayBuffer(file)
}

async function cerrarConfiguracion() {
  if (!configuracion.value) return
  loadingAccion.value = true
  const result = await configStore.cerrar(configuracion.value.id_configuracion)
  if (result.ok && result.data) {
    configuracion.value = result.data
    mostrarMensaje('Formularios cerrados correctamente.', 'positivo')
  } else {
    mostrarMensaje(primerError(result, 'Error al cerrar los formularios.'), 'error')
  }
  loadingAccion.value = false
}

async function sincronizar() {
  if (!configuracion.value) return
  loadingAccion.value = true
  const result = await configStore.sincronizar(configuracion.value.id_configuracion)
  if (result.ok) {
    // El % de participación se refresca con lo que devuelve la sincronización.
    if (result.data?.participacion) participacion.value = result.data.participacion
    mostrarMensaje(`Sincronización completada. Respuestas nuevas: ${result.data?.respuestas_nuevas ?? 0}`, 'positivo')
    await configStore.cargarRespuestas(configuracion.value.id_configuracion)
    respuestas.value = [...configStore.respuestas]
    if (!grupoActivoRespuestas.value && respuestas.value.length) {
      grupoActivoRespuestas.value = respuestas.value[0].id_formulario_google
    }
  } else {
    mostrarMensaje(primerError(result, 'Error al sincronizar.'), 'error')
  }
  loadingAccion.value = false
}

/**
 * Lleva a la calificación por pregunta. La ejecución se propaga si viene en la
 * URL: sin ella el par pregunta-respuesta se guarda sin ámbito y no queda
 * disponible para reutilizar.
 */
function irACalificarPorPregunta() {
  if (!configuracion.value?.id_configuracion) return
  router.push({
    name: 'CalificarInstrumentoOpinion',
    params: { id_configuracion: configuracion.value.id_configuracion },
    query: {
      ...(route.query.id_ejecucion ? { id_ejecucion: route.query.id_ejecucion } : {}),
      escala_max: escalaMax.value
    }
  })
}

function copiarUrl(url: string) {
  navigator.clipboard.writeText(url).then(() => {
    mostrarMensaje('Link copiado al portapapeles.', 'positivo')
  })
}

function respuestasDe(rf: RespuestasFormulario, responseId: string): RespuestaIndividual[] {
  return rf.respuestas.filter(r => r.google_response_id === responseId)
}

function agruparPorPregunta(lista: RespuestaIndividual[]): Record<number, GrupoRespuesta> {
  const mapa: Record<number, GrupoRespuesta> = {}
  for (const r of lista) {
    if (!mapa[r.id_pregunta]) {
      mapa[r.id_pregunta] = { enunciado: r.enunciado, tieneValores: false, promedio: 0, textos: [] }
    }
    const g = mapa[r.id_pregunta]
    if (r.valor !== null) {
      g.tieneValores = true
      g.promedio = g.promedio + r.valor
    }
    if (r.texto) g.textos.push({ texto: r.texto, nombre: r.nombre_respondiente || r.email_respondiente || 'Anónimo' })
  }
  const conteo: Record<number, number> = {}
  for (const r of lista) {
    if (r.valor !== null) conteo[r.id_pregunta] = (conteo[r.id_pregunta] ?? 0) + 1
  }
  for (const [id, g] of Object.entries(mapa)) {
    if (g.tieneValores && conteo[Number(id)]) {
      g.promedio = g.promedio / conteo[Number(id)]
    }
  }
  return mapa
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loading.value,
      message: "Cargando configuración…"
    }, null, 8, ["visible"]),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "fo-titulo" }, "Ficha de Opinión", -1)),
          (nombreVersion.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(nombreVersion.value), 1))
            : _createCommentVNode("", true),
          (instrumento.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(instrumento.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "btn volver",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, "Volver")
      ])
    ]),
    (!loading.value && !configuracion.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "fo-aviso-titulo" }, "Este formulario aún no ha sido aplicado", -1)),
            _createElementVNode("p", _hoisted_8, [
              _cache[15] || (_cache[15] = _createTextVNode(" El cuestionario ")),
              _createElementVNode("strong", null, _toDisplayString(instrumentoNombre.value || 'de opinión'), 1),
              _cache[16] || (_cache[16] = _createTextVNode(" ya existe con sus preguntas configuradas. Para poder enviar el formulario a los encuestados, primero debe registrar su vigencia y título. "))
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("ul", { class: "fo-aviso-pasos" }, [
              _createElementVNode("li", null, "Complete el título que verán los encuestados y el período de vigencia."),
              _createElementVNode("li", null, "Guarde para generar los formularios de Google."),
              _createElementVNode("li", null, "Publique y asigne destinatarios para comenzar a recibir respuestas.")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[19] || (_cache[19] = _createElementVNode("label", null, "Título que verán los encuestados", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formNueva.titulo) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Encuesta de satisfacción 2026"
              }, null, 512), [
                [_vModelText, formNueva.titulo]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[20] || (_cache[20] = _createElementVNode("label", null, "Instrucciones", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formNueva.instrucciones) = $event)),
                rows: "2",
                class: "form-control",
                placeholder: "Responda según su experiencia…"
              }, null, 512), [
                [_vModelText, formNueva.instrucciones]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[21] || (_cache[21] = _createElementVNode("label", null, "Vigencia desde", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formNueva.vigencia_desde) = $event)),
                  type: "date",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, formNueva.vigencia_desde]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, "Vigencia hasta", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formNueva.vigencia_hasta) = $event)),
                  type: "date",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, formNueva.vigencia_hasta]
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: creando.value || !formNueva.titulo.trim(),
              onClick: crearConfiguracion
            }, _toDisplayString(creando.value ? 'Generando…' : 'Aplicar y generar formularios'), 9, _hoisted_15)
          ])
        ]))
      : (configuracion.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { style: {"margin-top":"16px"} }, null, -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", {
                  class: _normalizeClass(['estado-badge', `estado-${configuracion.value.estado}`])
                }, _toDisplayString(configuracion.value.estado), 3),
                _createElementVNode("span", _hoisted_18, " Vigencia: " + _toDisplayString(formatearFecha(configuracion.value.vigencia_desde)) + " → " + _toDisplayString(formatearFecha(configuracion.value.vigencia_hasta)), 1),
                (configuracion.value.estado === 'borrador')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn guardar btn-sm",
                      disabled: publicando.value,
                      onClick: publicarConfiguracion
                    }, _toDisplayString(publicando.value ? 'Publicando…' : 'Publicar formularios'), 9, _hoisted_19))
                  : _createCommentVNode("", true)
              ]),
              (configuraciones.value.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "config-selector-label" }, "Período:", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((configSeleccionadaId).value = $event)),
                      class: "config-select",
                      onChange: cargarConfigSeleccionada
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configuraciones.value, (c) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: c.id_configuracion,
                          value: c.id_configuracion
                        }, _toDisplayString(formatearFecha(c.vigencia_desde)) + " → " + _toDisplayString(formatearFecha(c.vigencia_hasta)) + " (" + _toDisplayString(c.estado) + ") ", 9, _hoisted_21))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, configSeleccionadaId.value]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (configuracion.value.titulo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(configuracion.value.titulo), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "fi-lbl" }, "Indicadores que cubre este formulario", -1)),
                  (indicadoresCubiertos.value.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "fi-toggle",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (indicadoresExpandidos.value = !indicadoresExpandidos.value))
                      }, _toDisplayString(indicadoresExpandidos.value ? 'Ocultar' : `Mostrar (${indicadoresCubiertos.value.length})`), 1))
                    : _createCommentVNode("", true)
                ]),
                (indicadoresCubiertos.value.length && indicadoresExpandidos.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicadoresCubiertos.value, (ind) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: ind.id_indicador,
                          class: "item-cubierto"
                        }, [
                          (ind.ordinal)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(ind.ordinal), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_28, [
                            _createElementVNode("strong", _hoisted_29, _toDisplayString(ind.aspecto || '—'), 1),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(ind.enunciado || '—'), 1)
                          ]),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(ind.preguntas) + " pregunta" + _toDisplayString(ind.preguntas === 1 ? '' : 's'), 1)
                        ]))
                      }), 128))
                    ]))
                  : (!indicadoresCubiertos.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Ninguna pregunta de este formulario tiene indicador asignado todavía. Vincúlalo desde la vista de indicadores. "))
                    : _createCommentVNode("", true)
              ]),
              (configuracion.value.instrucciones)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "fi-lbl" }, "Instrucciones", -1)),
                    _createElementVNode("p", null, _toDisplayString(configuracion.value.instrucciones), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: tab.id,
                  class: _normalizeClass(['tab-btn', { 'tab-btn--activo': tabActiva.value === tab.id }]),
                  onClick: ($event: any) => (tabActiva.value = tab.id)
                }, [
                  _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                  (tab.badge)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(tab.badge), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_35))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_37, [
              (tabActiva.value === 'formularios')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    (!formularios.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Sin formularios generados."))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formularios.value, (f) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: f.id_formulario_google,
                        class: "form-card"
                      }, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("strong", null, _toDisplayString(f.grupo_interes?.nombre ?? `Formulario ${f.id_formulario_google}`), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(['estado-badge', `estado-${f.estado}`])
                            }, _toDisplayString(f.estado), 3)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            (f.google_form_url)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm guardar",
                                    onClick: ($event: any) => (copiarUrl(f.google_form_url!))
                                  }, "Copiar link", 8, _hoisted_43),
                                  _createElementVNode("a", {
                                    href: f.google_form_url,
                                    target: "_blank",
                                    rel: "noopener",
                                    class: "btn btn-sm guardar"
                                  }, "Abrir", 8, _hoisted_44)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_45, "URL pendiente")),
                            (configuracion.value!.estado === 'publicada')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "btn btn-sm salir",
                                  disabled: loadingAccion.value,
                                  onClick: cerrarConfiguracion
                                }, " Cerrar formularios ", 8, _hoisted_46))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (f.preguntas_snapshot?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.preguntas_snapshot, (p, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: p.id_pregunta,
                                  class: "snapshot-item"
                                }, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(i + 1), 1),
                                    _createElementVNode("span", _hoisted_50, _toDisplayString(p.enunciado), 1)
                                  ]),
                                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "snap-respuesta-area" }, [
                                    _createElementVNode("span", { class: "snap-respuesta-placeholder" }, "Espacio para respuesta")
                                  ], -1))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (tabActiva.value === 'destinatarios')
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    (configuracion.value!.estado === 'cerrada')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, " Formularios cerrados — solo lectura. "))
                      : _createCommentVNode("", true),
                    (formularios.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formularios.value, (f) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: f.id_formulario_google,
                              class: _normalizeClass(['dest-tab-btn', { 'dest-tab-btn--activo': grupoActivo.value === f.id_formulario_google }]),
                              onClick: ($event: any) => (grupoActivo.value = f.id_formulario_google)
                            }, [
                              _createTextVNode(_toDisplayString(f.grupo_interes?.nombre ?? `Grupo ${f.id_formulario_google}`) + " ", 1),
                              (f.destinatarios?.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(f.destinatarios.length), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_54))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formularios.value, (f) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: f.id_formulario_google
                      }, [
                        (grupoActivo.value === f.id_formulario_google)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              (f.destinatarios?.length)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_57, [
                                    _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Email"),
                                        _createElementVNode("th", null, "Estado envío"),
                                        _createElementVNode("th", null, "Enviado")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.destinatarios, (d) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: d.email
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(d.email), 1),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(['estado-badge', `estado-envio-${d.estado_envio}`])
                                            }, _toDisplayString(d.estado_envio), 3)
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(formatearFecha(d.enviado_at)), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_58, "Sin destinatarios asignados.")),
                              (configuracion.value!.estado === 'publicada')
                                ? (_openBlock(), _createBlock(ContactosPreviosSelector, {
                                    key: 2,
                                    idGrupoInteres: f.id_grupo_interes ?? null,
                                    idPrograma: idPrograma.value,
                                    idEjecucion: idEjecucionActual.value,
                                    onAgregar: ($event: any) => (agregarContactosPrevios(f.id_formulario_google, $event))
                                  }, null, 8, ["idGrupoInteres", "idPrograma", "idEjecucion", "onAgregar"]))
                                : _createCommentVNode("", true),
                              (configuracion.value!.estado === 'publicada')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "dest-label" }, "Agregar nuevos correos (uno por línea)", -1)),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-sm guardar",
                                        onClick: ($event: any) => (abrirExcel(f.id_formulario_google))
                                      }, " Cargar desde Excel ", 8, _hoisted_61)
                                    ]),
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": ($event: any) => ((correosInput.value[f.id_formulario_google]) = $event),
                                      class: "dest-textarea",
                                      placeholder: "usuario@ejemplo.com\notro@ejemplo.com",
                                      rows: "4"
                                    }, null, 8, _hoisted_62), [
                                      [_vModelText, correosInput.value[f.id_formulario_google]]
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("label", _hoisted_64, [
                                        _cache[29] || (_cache[29] = _createElementVNode("span", null, "Afiliado desde", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "date",
                                          "onUpdate:modelValue": ($event: any) => ((vigenciaDesde.value[f.id_formulario_google]) = $event)
                                        }, null, 8, _hoisted_65), [
                                          [_vModelText, vigenciaDesde.value[f.id_formulario_google]]
                                        ])
                                      ]),
                                      _createElementVNode("label", _hoisted_66, [
                                        _cache[30] || (_cache[30] = _createElementVNode("span", null, "Vigente hasta", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "date",
                                          "onUpdate:modelValue": ($event: any) => ((vigenciaHasta.value[f.id_formulario_google]) = $event)
                                        }, null, 8, _hoisted_67), [
                                          [_vModelText, vigenciaHasta.value[f.id_formulario_google]]
                                        ])
                                      ]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "cp-link",
                                        onClick: ($event: any) => (vigenciaCincoAnios(f.id_formulario_google))
                                      }, " 5 años ", 8, _hoisted_68)
                                    ]),
                                    _cache[31] || (_cache[31] = _createElementVNode("p", { class: "vigencia-ayuda" }, " Pasada la fecha de vigencia el correo desaparece del banco y no se vuelve a ofrecer. Si lo dejas en blanco, no caduca. ", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (configuracion.value!.estado === 'publicada')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _createElementVNode("button", {
                                      class: "btn guardar",
                                      disabled: loadingAccion.value || !correosInput.value[f.id_formulario_google]?.trim(),
                                      onClick: ($event: any) => (asignarDestinatariosGrupo(f.id_formulario_google))
                                    }, _toDisplayString(loadingAccion.value ? 'Enviando…' : 'Enviar a este grupo'), 9, _hoisted_70)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (tabActiva.value === 'respuestas')
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("span", _hoisted_73, _toDisplayString(totalRespuestas.value) + " respuesta(s)", 1),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("button", {
                          class: _normalizeClass(['vista-btn', { 'vista-btn--activo': vistaRespuestas.value === 'pregunta' }]),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (vistaRespuestas.value = 'pregunta'))
                        }, "Por pregunta", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(['vista-btn', { 'vista-btn--activo': vistaRespuestas.value === 'persona' }]),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (vistaRespuestas.value = 'persona'))
                        }, "Por persona", 2)
                      ]),
                      (participacion.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["participacion-badge", { 'participacion-badge--vacio': participacion.value.porcentaje === null }]),
                            title: tituloParticipacion.value
                          }, [
                            (participacion.value.porcentaje !== null)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" Participación " + _toDisplayString(participacion.value.porcentaje) + "% ", 1),
                                  _createElementVNode("small", null, "(" + _toDisplayString(participacion.value.respondieron) + "/" + _toDisplayString(participacion.value.correos_enviados) + " correos)", 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[32] || (_cache[32] = _createTextVNode("Participación — ")),
                                  _cache[33] || (_cache[33] = _createElementVNode("small", null, "(sin correos enviados)", -1))
                                ], 64))
                          ], 10, _hoisted_75))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn guardar btn-sm",
                        disabled: loadingAccion.value,
                        onClick: sincronizar
                      }, _toDisplayString(loadingAccion.value ? 'Sincronizando…' : 'Sincronizar respuestas'), 9, _hoisted_76)
                    ]),
                    (!respuestas.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Sin respuestas registradas. Sincroniza para actualizar. "))
                      : _createCommentVNode("", true),
                    (respuestas.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(respuestas.value, (rf) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: rf.id_formulario_google,
                              class: _normalizeClass(['dest-tab-btn', { 'dest-tab-btn--activo': grupoActivoRespuestas.value === rf.id_formulario_google }]),
                              onClick: ($event: any) => {grupoActivoRespuestas.value = rf.id_formulario_google; personaFiltrada.value = null}
                            }, [
                              _createTextVNode(_toDisplayString(rf.grupo_interes?.nombre ?? `Grupo ${rf.id_formulario_google}`) + " ", 1),
                              (rf.respuestas.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(rf.respuestas.length), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_79))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(respuestas.value, (rf) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: rf.id_formulario_google
                      }, [
                        (grupoActivoRespuestas.value === rf.id_formulario_google)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                              (rf.respondientes?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _createElementVNode("span", _hoisted_83, "Respondieron (" + _toDisplayString(rf.respondientes.length) + "):", 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rf.respondientes, (p) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: p.google_response_id,
                                        class: "resp-persona-chip",
                                        title: p.email || ''
                                      }, _toDisplayString(p.nombre || p.email || 'Anónimo'), 9, _hoisted_84))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (vistaRespuestas.value === 'pregunta')
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(agruparPorPregunta(rf.respuestas), (grupo, idPregunta) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: idPregunta,
                                      class: "resp-pregunta"
                                    }, [
                                      _createElementVNode("p", _hoisted_85, _toDisplayString(grupo.enunciado), 1),
                                      (grupo.tieneValores)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "prom-label" }, "Promedio", -1)),
                                            _createElementVNode("span", _hoisted_87, _toDisplayString(grupo.promedio.toFixed(2)), 1),
                                            _createElementVNode("div", _hoisted_88, [
                                              _createElementVNode("div", {
                                                class: "prom-bar",
                                                style: _normalizeStyle({ width: `${(grupo.promedio / 5) * 100}%` })
                                              }, null, 4)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (grupo.textos.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_89, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.textos, (t, i) => {
                                              return (_openBlock(), _createElementBlock("li", { key: i }, [
                                                _createElementVNode("span", _hoisted_90, _toDisplayString(t.nombre) + ":", 1),
                                                _createTextVNode(" " + _toDisplayString(t.texto), 1)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (rf.respondientes?.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                          _cache[36] || (_cache[36] = _createElementVNode("label", { class: "persona-filtro-label" }, "Filtrar por persona:", -1)),
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((personaFiltrada).value = $event)),
                                            class: "persona-filtro-select"
                                          }, [
                                            _cache[35] || (_cache[35] = _createElementVNode("option", { value: null }, "— Todos —", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rf.respondientes, (r) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: r.google_response_id,
                                                value: r.google_response_id
                                              }, _toDisplayString(r.nombre || r.email || 'Anónimo'), 9, _hoisted_92))
                                            }), 128))
                                          ], 512), [
                                            [_vModelSelect, personaFiltrada.value]
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!rf.respondientes?.length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_93, "Aún no hay respuestas."))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((personaFiltrada.value ? rf.respondientes?.filter(r => r.google_response_id === personaFiltrada.value) : rf.respondientes), (p) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: p.google_response_id,
                                        class: "persona-card"
                                      }, [
                                        _createElementVNode("div", _hoisted_94, [
                                          _createElementVNode("strong", _hoisted_95, _toDisplayString(p.nombre || p.email || 'Anónimo'), 1),
                                          (p.nombre && p.email)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(p.email), 1))
                                            : _createCommentVNode("", true),
                                          (rf.grupo_interes?.nombre)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_97, "→ " + _toDisplayString(rf.grupo_interes.nombre), 1))
                                            : _createCommentVNode("", true),
                                          (p.respondido_at)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(p.respondido_at.substring(0, 10)), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("ul", _hoisted_99, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(respuestasDe(rf, p.google_response_id), (r) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              key: r.id_respuesta
                                            }, [
                                              _createElementVNode("span", _hoisted_100, _toDisplayString(r.enunciado), 1),
                                              _createElementVNode("span", _hoisted_101, _toDisplayString(r.texto ?? r.valor ?? '—'), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    }), 128))
                                  ], 64))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (tabActiva.value === 'calificacion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    (indicadoresCubiertos.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "cal-existente-head" }, "Calificación por indicador", -1)),
                          _createElementVNode("ul", _hoisted_104, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicadoresCubiertos.value, (ind) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: ind.id_indicador,
                                class: "cal-item-ind"
                              }, [
                                _createElementVNode("div", _hoisted_105, [
                                  (ind.ordinal)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(ind.ordinal), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_107, [
                                    _createElementVNode("strong", null, _toDisplayString(ind.enunciado || '—'), 1),
                                    (ind.aspecto)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(ind.aspecto), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (ind.calificacion?.opinion != null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "cal-label" }, "Opinión", -1)),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(['cal-valor', 'cal-nota', claseSemaforoDesdeNivel(ind.calificacion.nivel)])
                                        }, _toDisplayString(ind.calificacion.opinion.toFixed(2)), 3)
                                      ]),
                                      (ind.calificacion.final != null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "cal-label" }, "Final ponderada", -1)),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(['cal-valor', 'cal-nota', claseSemaforoDesdeNivel(ind.calificacion.nivel)])
                                            }, _toDisplayString(ind.calificacion.final.toFixed(2)), 3)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (ind.calificacion.nivel)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "cal-label" }, "Nivel", -1)),
                                            _createElementVNode("span", _hoisted_113, _toDisplayString(ind.calificacion.nivel), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_114, [
                                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "cal-label" }, "Preguntas calificadas", -1)),
                                        _createElementVNode("span", _hoisted_115, _toDisplayString(ind.calificacion.preguntas_calificadas ?? 0) + " de " + _toDisplayString(ind.preguntas), 1)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_116, "Sin calificar."))
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (esFormularioCompleto.value)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 1,
                          class: "cal-form",
                          onSubmit: _withModifiers(calificarCompleto, ["prevent"])
                        }, [
                          _createElementVNode("h4", null, _toDisplayString(hayCalificacion.value ? 'Corregir la calificación' : 'Registrar calificación'), 1),
                          _cache[44] || (_cache[44] = _createElementVNode("p", { class: "cal-aviso" }, [
                            _createTextVNode(" Este formulario califica como "),
                            _createElementVNode("strong", null, "una sola unidad"),
                            _createTextVNode(": la nota que registres es la del indicador, leyendo las respuestas tal como llegaron. ")
                          ], -1)),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("label", null, "Nota (" + _toDisplayString(escalaMax.value > 5 ? `1 – ${escalaMax.value}` : `0 – ${escalaMax.value}`) + ")", 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formCal.valor) = $event)),
                              min: escalaMax.value > 5 ? 1 : 0,
                              max: escalaMax.value,
                              step: "0.01",
                              required: "",
                              class: "form-control input-nota"
                            }, null, 8, _hoisted_118), [
                              [
                                _vModelText,
                                formCal.valor,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_119, [
                            _cache[42] || (_cache[42] = _createElementVNode("label", null, "Observación", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formCal.observacion) = $event)),
                              class: "form-control",
                              rows: "3",
                              placeholder: "Análisis de lo que se recogió…"
                            }, null, 512), [
                              [_vModelText, formCal.observacion]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_120, [
                            _cache[43] || (_cache[43] = _createElementVNode("label", null, "Comparación con períodos anteriores", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formCal.comparacion) = $event)),
                              class: "form-control",
                              rows: "2",
                              placeholder: "Comparación…"
                            }, null, 512), [
                              [_vModelText, formCal.comparacion]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_121, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn guardar",
                              disabled: loadingAccion.value
                            }, _toDisplayString(loadingAccion.value ? 'Guardando…' : 'Guardar calificación'), 9, _hoisted_122)
                          ])
                        ], 32))
                      : (_openBlock(), _createElementBlock("div", _hoisted_123, [
                          _createElementVNode("h4", null, _toDisplayString(hayCalificacion.value ? 'Continuar o corregir la calificación' : 'Registrar calificación'), 1),
                          _createElementVNode("p", _hoisted_124, [
                            _cache[45] || (_cache[45] = _createTextVNode(" La calificación de opinión se hace ")),
                            _cache[46] || (_cache[46] = _createElementVNode("strong", null, "pregunta por pregunta", -1)),
                            _cache[47] || (_cache[47] = _createTextVNode(", mostrando aspecto, indicador, pregunta y respuestas junto a la rúbrica. Escala de calificación: ")),
                            _createElementVNode("strong", null, _toDisplayString(escalaMax.value > 5 ? `1 – ${escalaMax.value}` : `0 – ${escalaMax.value}`), 1),
                            _cache[48] || (_cache[48] = _createTextVNode(". "))
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn guardar",
                            disabled: !configuracion.value,
                            onClick: irACalificarPorPregunta
                          }, " Calificar por pregunta ", 8, _hoisted_125)
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[13] || (_cache[13] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"]),
    _createElementVNode("input", {
      ref_key: "fileInputRef",
      ref: fileInputRef,
      type: "file",
      accept: ".xlsx,.xls,.csv",
      style: {"display":"none"},
      onChange: onArchivoExcel
    }, null, 544)
  ]))
}
}

})